import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal from '@partials/contents-modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class ReportDownload extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal : false,
      detail: {},
      edit_mode : false,
    };
  }
  // -------------------------------------------------------
  
  toggleEditMode(flg) {
    this.setState({ edit_mode: flg });
  }
  // -------------------------------------------------------
  
  toogleModal(flg) {
    if( flg == true ){
      Utils.request.bind(this)('/api/project/workflow/get_report_pptx', { project_id: this.props.data.project.id },
        function(res){
          this.setState({ modal: true, detail: res.body.report, edit_mode: false });
          
          if( flg == true  ) Utils.fixedContents();
          if( flg == false ){
            Utils.unlockFixedContents();
          }
        }.bind(this)
      );
    } else {
      this.setState({ modal: false });
    }
  }
  // -------------------------------------------------------
  
  registerReport() {
    let data = this.props.data;
    
    Utils.request.bind(this)('/api/project/workflow/setting_report_pptx', { project_id: data.project.id, mode: 'register' },
      function(res){
        alert('レポートを生成します。完了までしばらくお待ち下さい。');
        this.setState({ detail: res.body.report });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  updateReport(report) {
    this.setState({ detail: report });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.state.detail;
    
    let height = (this.state.edit_mode == true) ? 460 : 300;
    
    return (
      <div className="project-report-download">
        
        <div className="buttons">
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>PPTXレポートのダウンロード</Tooltip>}>
            <div onClick={this.toogleModal.bind(this, true)}><i className="material-icons">download</i></div>
          </OverlayTrigger>
        </div>
        
        <ContentsModal
          view     = {this.state.modal}
          width    = {600}
          height   = {height}
          close_ev = {this.toogleModal.bind(this, false)}
          html     = {
            <div className="modal-item">
              <div className="report-main-contents">
                
                <h3>レポートのダウンロード</h3>
                
                { (Object.keys(detail).length == 0)
                  ? <div className="button create-button" onClick={this.registerReport.bind(this)}>レポートを生成する</div>
                  : <ReportDownloadDetail
                      data={data}
                      detail={detail}
                      edit_mode={this.state.edit_mode}
                      toggle_ev={this.toggleEditMode.bind(this)}
                      update_ev={this.updateReport.bind(this)}
                      reload_ev={this.registerReport.bind(this)}
                    />
                }
                
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class ReportDownloadDetail extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let now_projects = [];
    try { now_projects = detail.project_ids.split(','); } catch(e) {}
    
    this.state = {
      multi_project_modal : false,
      now_projects: now_projects,
    };
  }
  // -------------------------------------------------------
  
  toogleModal(flg) {
    this.setState({ multi_project_modal: flg });
  }
  // -------------------------------------------------------
  
  reloadReport() {
    let chk = confirm('レポートを更新します。反映まで少々時間が掛かりますがよろしいですか？');
    if( chk == false ) return;
    
    this.props.reload_ev.bind(this)();
  }
  // -------------------------------------------------------
  
  updateReport() {
    let data = this.props.data;
    
    let option = { design: this.design.value, agenda_flg: this.agenda_flg.value, project_ids: this.state.now_projects.join() };
    
    Utils.request.bind(this)('/api/project/workflow/setting_report_pptx', { project_id: data.project.id, mode: 'setting', option: option },
      function(res){
        alert('レポートの設定を更新しました。データの生成までしばらくお待ち下さい。');
        this.props.update_ev.bind(this)(res.body.report);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  addProject() {
    let now_projects = this.state.now_projects;
    now_projects.push(this.new_project_id.value);
    now_projects = now_projects.filter((id) => { if( id != '' ) return id; });
    this.setState({ now_projects: now_projects });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.props.detail;
    
    if( detail.complete == 0 ){
      return <div className="none">レポート生成中</div>
    }
    
    let urls = [];
    try { urls = detail.file_url.split(','); } catch(e) {}
    urls = urls.filter((d) => { if( d != '' ) return d; });
    
    let projects = [];
    detail.projects.map((d) => { if( d.id != data.project.id && this.state.now_projects.indexOf(d.id) == -1 ) projects.push(d); });
    
    //console.log(projects);
    //console.log(this.state.now_projects);
    
    return (
      <div className="report-download-detail">
        
        <div className="reload-space">
          <h6>最終更新日：{Utils.setDate(detail.batch_date, 'YYYY/M/D HH:mm')}</h6>
          <p className="reload button" onClick={this.reloadReport.bind(this)}>レポートを更新する</p>
        </div>
        
        <div className="download-box">
          <div className="download-item">
            <h4>レポートデータ {( urls.length > 1) && ' （レポート数が多いので分割されています）'}</h4>
            <div className="download-files">
              { urls.map((url, key) => {
                let name = (urls.length > 1) ? 'PPTX'+ (key+1) : 'PPTX';
                return <p key={key} className="ok"><a href={url} target="_blank"><i className="material-icons">article</i>{name}</a></p>
              })}
            </div>
          </div>
          
          <div className="download-item">
            <h4>画像・動画素材</h4>
            <div className="download-files">
              { (detail.zip_url != null)
                ? <p className="ok"><a href={detail.zip_url} target="_blank"><i className="material-icons">folder_zip</i>ZIP</a></p>
                : <p className="none">ZIPファイルの生成に失敗しました</p>
              }
            </div>
          </div>
        </div>
        
        { (this.props.edit_mode == false)
          ? <div className="button setting-button" onClick={this.props.toggle_ev.bind(this, true)}><i className="material-icons">settings</i>レポートの設定を変更する</div>
          : <div className="report-setting-box">
              <div className="button setting-button" onClick={this.props.toggle_ev.bind(this, false)}><i className="material-icons">close</i>レポートの設定を閉じる</div>
              
              <div className="setting-columns">
                <div className="setting-item">
                  <h6>デザイン</h6>
                  <div className="selectbox">
                    <select ref={(input) => { this.design = input }} defaultValue={detail.design}>
                      { detail.designs.map((d, key) => {
                        return <option key={key} value={d.design_id}>{d.name}</option>
                       })}
                    </select>
                  </div>
                </div>
                
                <div className="setting-item">
                  <h6>アジェンダ</h6>
                  <div className="selectbox">
                    <select ref={(input) => { this.agenda_flg = input }} defaultValue={detail.agenda_flg}>
                      <option value="0">入れない</option>
                      <option value="1">入れる</option>
                    </select>
                  </div>
                </div>
                
                <div className="setting-item">
                  <h6>複数プロジェクト</h6>
                  <div className="button" onClick={this.toogleModal.bind(this, true)}>変更</div>
                </div>
                
              </div>
              
              <div className="button" onClick={this.updateReport.bind(this)}>保存</div>
            </div>
        }
        
        
        <ContentsModal
          view     = {this.state.multi_project_modal}
          width    = {300}
          height   = {600}
          close_ev = {this.toogleModal.bind(this, false)}
          html     = {
            <div className="modal-item">
              <div className="report-main-contents">
                
                <h3>プロジェクトの設定</h3>
                
                <div className="selectbox">
                  <select ref={(input) => { this.new_project_id = input }}>
                    <option value="null">追加したいプロジェクトを選択</option>
                    { projects.map((d, key) => {
                      return <option key={key} value={d.id}>{d.title}</option>
                     })}
                  </select>
                </div>
                
                <div className="button" onClick={this.addProject.bind(this)}>追加</div>
                <div className="button" onClick={this.toogleModal.bind(this, false)}>閉じる</div>
                
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ReportDownload;